export enum THGActionType {
    INFOMAIL = 'infomail',
    REGISTRATION_DECLINE = 'registration-decline', // registration declined
    SUBMISSION = 'submission',
    RECEIVING = 'receiving',
    DECLINE = 'decline', // declined by 'Umweltbundesamt'
    PAYOUT = 'payout',
    PROMO_PREMIUM_PAYOUT = 'promo-premium-payout',
    OVERRIDE_CO2_EQUIVALENT = 'override-co2-equivalent',
    OVERRIDE_STATUS_DATA_RECEIVED = 'override-status-data-received',
    OVERRIDE_STATUS_UBA_SUBMITTED = 'override-status-uba-submitted',
    OVERRIDE_STATUS_CERT_RECEIVED = 'override-status-cert-received',
    OVERRIDE_STATUS_INCOME_PAID_OUT = 'override-status-income-paid-out',
    OVERRIDE_STATUS_CERT_DECLINED = 'override-status-cert-declined',
    RENEW = 'renew',
    BULK_ADD_TAGS = 'bulk-add-tags',
}
